import React from "react";
import { cn } from "../../utils/cn";

interface CheckboxProps {
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
  label?: string;
  checkboxLabel?: string;
  errors?: string;
  name?: string;
}

const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  onChange,
  className,
  label,
  checkboxLabel,
  errors,
  name,
}) => {
  return (
    <div className="flex w-full flex-col gap-2">
      {label && (
        <span className="text-cream-800 dark:text-cream-400 text-sm font-medium">
          {label}
        </span>
      )}
      <label className="flex items-start gap-2">
        {name && <input type="hidden" name={name} value="0" />}
        <input
          type="checkbox"
          name={name}
          value="1"
          checked={checked}
          onChange={onChange}
          className={cn(
            "border-cream-500 text-peach-500 focus:ring-peach-300 dark:bg-cream-800 mt-1 h-4 w-4 rounded border",
            className,
          )}
        />
        {checkboxLabel && (
          <span className="text-cream-950 dark:text-cream-100 font-medium">
            {checkboxLabel}
          </span>
        )}
      </label>
      {errors && (
        <span className="text-peach-600 dark:text-peach-400 text-sm font-semibold">
          {errors}
        </span>
      )}
    </div>
  );
};

export default Checkbox;
